export default __webpack_public_path__ + "static/media/girl_home.df44b54a.png";